import { getRegion } from 'src/api/config';

export const values_default = {
  type: 'EMR_GROUP',
  name: '',
  description: 'Emr resource group',
  emrGroupConfig: {
    accountId: '',
    region: 'us-east-1',
    emrManagementRoleArn: '',
    configurations: {
      'capacity-scheduler': {
        'yarn.scheduler.capacity.resource-calculator':
          'org.apache.hadoop.yarn.util.resource.DominantResourceCalculator',
      },
      'emrfs-site': {
        'fs.s3.canned.acl': 'BucketOwnerFullControl',
      },
      'hive-site': {
        'hive.metastore.client.factory.class':
          'com.amazonaws.glue.catalog.metastore.AWSGlueDataCatalogHiveClientFactory',
      },
      'spark-defaults': {
        'spark.pyspark.python': 'python3.6',
        'spark.yarn.appMasterEnv.PYTHONHASHSEED': '0',
      },
      'spark-env': {
        PYSPARK_PYTHON: 'python3.6',
        PYTHONHASHSEED: '0',
        PYTHONPATH: "'/home/hadoop:/home/hadoop/emr_sniper:/home/hadoop/bin:/home/hadoop/bin/lib:'$PYTHONPATH",
        'SPARK_YARN_USER_ENV=PYSPARK_PYTHON': 'python3.6',
      },
      'spark-hive-site': {
        'hive.metastore.client.factory.class':
          'com.amazonaws.glue.catalog.metastore.AWSGlueDataCatalogHiveClientFactory',
      },
    },
    configurationsJsonString: '[]',
    clusterRefreshDays: '30',
    clusterRefreshDayHoursInUTC: [9, 10, 11, 12, 13, 14, 15, 16],
    clusterRefreshWeekDaysInUTC: [1, 2, 3, 4, 5],
    applications: ['Hive', 'Spark'],
    bootstrapActions: [],
    ec2SubnetIds: [],
    jobFlowRole: 'EMR_EC2_DefaultRole',
    serviceRole: 'EMR_DefaultRole',
    minClusters: '',
    maxClusters: '1',
    isAutoScalingEnabled: false,
    isEMRManagedScalingEnabled: false,
    coreInstanceCount: '',
    coreInstanceType: '',
    coreMarket: 'ON_DEMAND',
    masterInstanceCount: '',
    masterInstanceType: '',
    masterMarket: 'ON_DEMAND',
    releaseLabel: '',
    s3LogUri: '',
    securityConfiguration: '',
    emrManagedMasterSecurityGroup: '',
    emrManagedSlaveSecurityGroup: '',
    stepConcurrencyLevel: '1',
    customAmiId: '',
    installChronicle: true,
    installSSMPatch: true,
    taskInstanceCount: '',
    taskInstanceType: '',
    taskMarket: '',
    emrManagedScalingConfig: {
      unitType: '',
      minimumCapacityUnits: '0',
      maximumCapacityUnits: '1',
      maximumCoreCapacityUnits: '1',
      maximumOnDemandCapacityUnits: '1',
    },
  },
  notification: { enabled: false },
};

//From https://docs.aws.amazon.com/emr/latest/ManagementGuide/emr-supported-instance-types.html on 04/28/2025
const hardcodedEmrInstances = {
  'General purpose': [
    'm5.xlarge',
    'm5.2xlarge',
    'm5.4xlarge',
    'm5.8xlarge',
    'm5.12xlarge',
    'm5.16xlarge',
    'm5.24xlarge',
    'm5a.xlarge',
    'm5a.2xlarge',
    'm5a.4xlarge',
    'm5a.8xlarge',
    'm5a.12xlarge',
    'm5a.16xlarge',
    'm5a.24xlarge',
    'm5ad.xlarge',
    'm5ad.2xlarge',
    'm5ad.4xlarge',
    'm5ad.8xlarge',
    'm5ad.12xlarge',
    'm5ad.16xlarge',
    'm5ad.24xlarge',
    'm5d.xlarge',
    'm5d.2xlarge',
    'm5d.4xlarge',
    'm5d.8xlarge',
    'm5d.12xlarge',
    'm5d.16xlarge',
    'm5d.24xlarge',
    'm5dn.xlarge',
    'm5dn.2xlarge',
    'm5dn.4xlarge',
    'm5dn.8xlarge',
    'm5dn.12xlarge',
    'm5dn.16xlarge',
    'm5dn.24xlarge',
    'm5n.xlarge',
    'm5n.2xlarge',
    'm5n.4xlarge',
    'm5n.8xlarge',
    'm5n.12xlarge',
    'm5n.16xlarge',
    'm5n.24xlarge',
    'm5zn.xlarge',
    'm5zn.2xlarge',
    'm5zn.3xlarge',
    'm5zn.6xlarge',
    'm5zn.12xlarge',
    'm6a.xlarge',
    'm6a.2xlarge',
    'm6a.4xlarge',
    'm6a.8xlarge',
    'm6a.12xlarge',
    'm6a.16xlarge',
    'm6a.24xlarge',
    'm6a.32xlarge',
    'm6a.48xlarge',
    'm6g.xlarge',
    'm6g.2xlarge',
    'm6g.4xlarge',
    'm6g.8xlarge',
    'm6g.12xlarge',
    'm6g.16xlarge',
    'm6gd.xlarge',
    'm6gd.2xlarge',
    'm6gd.4xlarge',
    'm6gd.8xlarge',
    'm6gd.12xlarge',
    'm6gd.16xlarge',
    'm6i.xlarge',
    'm6i.2xlarge',
    'm6i.4xlarge',
    'm6i.8xlarge',
    'm6i.12xlarge',
    'm6i.16xlarge',
    'm6i.24xlarge',
    'm6i.32xlarge',
    'm6id.xlarge',
    'm6id.2xlarge',
    'm6id.4xlarge',
    'm6id.8xlarge',
    'm6id.12xlarge',
    'm6id.16xlarge',
    'm6id.24xlarge',
    'm6id.32xlarge',
    'm6idn.xlarge',
    'm6idn.2xlarge',
    'm6idn.4xlarge',
    'm6idn.8xlarge',
    'm6idn.12xlarge',
    'm6idn.16xlarge',
    'm6idn.24xlarge',
    'm6idn.32xlarge',
    'm6in.xlarge',
    'm6in.2xlarge',
    'm6in.4xlarge',
    'm6in.8xlarge',
    'm6in.12xlarge',
    'm6in.16xlarge',
    'm6in.24xlarge',
    'm6in.32xlarge',
    'm7a.xlarge',
    'm7a.2xlarge',
    'm7a.4xlarge',
    'm7a.8xlarge',
    'm7a.12xlarge',
    'm7a.16xlarge',
    'm7a.24xlarge',
    'm7a.32xlarge',
    'm7a.48xlarge',
    'm7g.xlarge',
    'm7g.2xlarge',
    'm7g.4xlarge',
    'm7g.8xlarge',
    'm7g.12xlarge',
    'm7g.16xlarge',
    'm7gd.xlarge',
    'm7gd.2xlarge',
    'm7gd.4xlarge',
    'm7gd.8xlarge',
    'm7gd.12xlarge',
    'm7gd.16xlarge',
    'm7i.xlarge',
    'm7i.2xlarge',
    'm7i.4xlarge',
    'm7i.8xlarge',
    'm7i.12xlarge',
    'm7i.16xlarge',
    'm7i.24xlarge',
    'm7i.48xlarge',
    'm7i-flex.xlarge',
    'm7i-flex.2xlarge',
    'm7i-flex.4xlarge',
    'm7i-flex.8xlarge',
    'm7i-flex.12xlarge',
    'm7i-flex.16xlarge',
    'm8g.xlarge',
    'm8g.2xlarge',
    'm8g.4xlarge',
    'm8g.8xlarge',
    'm8g.12xlarge',
    'm8g.16xlarge',
    'm8g.24xlarge',
    'm8g.48xlarge',
  ],
  'Compute-optimized': [
    'c5.2xlarge',
    'c5.4xlarge',
    'c5.9xlarge',
    'c5.12xlarge',
    'c5.18xlarge',
    'c5.24xlarge',
    'c5a.xlarge',
    'c5a.2xlarge',
    'c5a.4xlarge',
    'c5a.8xlarge',
    'c5a.12xlarge',
    'c5a.16xlarge',
    'c5a.24xlarge',
    'c5ad.xlarge',
    'c5ad.2xlarge',
    'c5ad.4xlarge',
    'c5ad.8xlarge',
    'c5ad.12xlarge',
    'c5ad.16xlarge',
    'c5ad.24xlarge',
    'c5d.xlarge',
    'c5d.2xlarge',
    'c5d.4xlarge',
    'c5d.9xlarge',
    'c5d.12xlarge',
    'c5d.18xlarge',
    'c5d.24xlarge',
    'c5n.xlarge',
    'c5n.2xlarge',
    'c5n.4xlarge',
    'c5n.9xlarge',
    'c5n.18xlarge',
    'c6a.xlarge',
    'c6a.2xlarge',
    'c6a.4xlarge',
    'c6a.8xlarge',
    'c6a.12xlarge',
    'c6a.16xlarge',
    'c6a.24xlarge',
    'c6a.32xlarge',
    'c6a.48xlarge',
    'c6g.xlarge',
    'c6g.2xlarge',
    'c6g.4xlarge',
    'c6g.8xlarge',
    'c6g.12xlarge',
    'c6g.16xlarge',
    'c6gd.xlarge',
    'c6gd.2xlarge',
    'c6gd.4xlarge',
    'c6gd.8xlarge',
    'c6gd.12xlarge',
    'c6gd.16xlarge',
    'c6gn.xlarge',
    'c6gn.2xlarge',
    'c6gn.4xlarge',
    'c6gn.8xlarge',
    'c6gn.12xlarge',
    'c6gn.16xlarge',
    'c6i.xlarge',
    'c6i.2xlarge',
    'c6i.4xlarge',
    'c6i.8xlarge',
    'c6i.12xlarge',
    'c6i.16xlarge',
    'c6i.24xlarge',
    'c6i.32xlarge',
    'c6id.xlarge',
    'c6id.2xlarge',
    'c6id.4xlarge',
    'c6id.8xlarge',
    'c6id.12xlarge',
    'c6id.16xlarge',
    'c6id.24xlarge',
    'c6id.32xlarge',
    'c6in.xlarge',
    'c6in.2xlarge',
    'c6in.4xlarge',
    'c6in.8xlarge',
    'c6in.12xlarge',
    'c6in.16xlarge',
    'c6in.24xlarge',
    'c6in.32xlarge',
    'c7a.xlarge',
    'c7a.2xlarge',
    'c7a.4xlarge',
    'c7a.8xlarge',
    'c7a.12xlarge',
    'c7a.16xlarge',
    'c7a.24xlarge',
    'c7a.32xlarge',
    'c7a.48xlarge',
    'c7g.xlarge',
    'c7g.2xlarge',
    'c7g.4xlarge',
    'c7g.8xlarge',
    'c7g.12xlarge',
    'c7g.16xlarge',
    'c7gd.xlarge',
    'c7gd.2xlarge',
    'c7gd.4xlarge',
    'c7gd.8xlarge',
    'c7gd.12xlarge',
    'c7gd.16xlarge',
    'c7gn.xlarge',
    'c7gn.2xlarge',
    'c7gn.4xlarge',
    'c7gn.8xlarge',
    'c7gn.12xlarge',
    'c7gn.16xlarge',
    'c7i.xlarge',
    'c7i.2xlarge',
    'c7i.4xlarge',
    'c7i.8xlarge',
    'c7i.12xlarge',
    'c7i.16xlarge',
    'c7i.24xlarge',
    'c7i.48xlarge',
    'c7i-flex.xlarge',
    'c7i-flex.2xlarge',
    'c7i-flex.4xlarge',
    'c7i-flex.8xlarge',
    'c7i-flex.12xlarge',
    'c7i-flex.16xlarge',
    'c8g.xlarge',
    'c8g.2xlarge',
    'c8g.4xlarge',
    'c8g.8xlarge',
    'c8g.12xlarge',
    'c8g.16xlarge',
    'c8g.24xlarge',
    'c8g.48xlarge',
  ],
  'Memory-optimized': [
    'r5.2xlarge',
    'r5.4xlarge',
    'r5.8xlarge',
    'r5.12xlarge',
    'r5.16xlarge',
    'r5.24xlarge',
    'r5a.xlarge',
    'r5a.2xlarge',
    'r5a.4xlarge',
    'r5a.8xlarge',
    'r5a.12xlarge',
    'r5a.16xlarge',
    'r5a.24xlarge',
    'r5ad.xlarge',
    'r5ad.2xlarge',
    'r5ad.4xlarge',
    'r5ad.8xlarge',
    'r5ad.12xlarge',
    'r5ad.16xlarge',
    'r5ad.24xlarge',
    'r5b.xlarge',
    'r5b.2xlarge',
    'r5b.4xlarge',
    'r5b.8xlarge',
    'r5b.12xlarge',
    'r5b.16xlarge',
    'r5b.24xlarge',
    'r5d.xlarge',
    'r5d.2xlarge',
    'r5d.4xlarge',
    'r5d.8xlarge',
    'r5d.12xlarge',
    'r5d.16xlarge',
    'r5d.24xlarge',
    'r5dn.xlarge',
    'r5dn.2xlarge',
    'r5dn.4xlarge',
    'r5dn.8xlarge',
    'r5dn.12xlarge',
    'r5dn.16xlarge',
    'r5dn.24xlarge',
    'r5n.xlarge',
    'r5n.2xlarge',
    'r5n.4xlarge',
    'r5n.8xlarge',
    'r5n.12xlarge',
    'r5n.16xlarge',
    'r5n.24xlarge',
    'r6a.xlarge',
    'r6a.2xlarge',
    'r6a.4xlarge',
    'r6a.8xlarge',
    'r6a.12xlarge',
    'r6a.16xlarge',
    'r6a.24xlarge',
    'r6a.32xlarge',
    'r6a.48xlarge',
    'r6g.xlarge',
    'r6g.2xlarge',
    'r6g.4xlarge',
    'r6g.8xlarge',
    'r6g.12xlarge',
    'r6g.16xlarge',
    'r6gd.xlarge',
    'r6gd.2xlarge',
    'r6gd.4xlarge',
    'r6gd.8xlarge',
    'r6gd.12xlarge',
    'r6gd.16xlarge',
    'r6i.xlarge',
    'r6i.2xlarge',
    'r6i.4xlarge',
    'r6i.8xlarge',
    'r6i.12xlarge',
    'r6i.16xlarge',
    'r6i.24xlarge',
    'r6i.32xlarge',
    'r6id.xlarge',
    'r6id.2xlarge',
    'r6id.4xlarge',
    'r6id.8xlarge',
    'r6id.12xlarge',
    'r6id.16xlarge',
    'r6id.24xlarge',
    'r6id.32xlarge',
    'r6idn.xlarge',
    'r6idn.2xlarge',
    'r6idn.4xlarge',
    'r6idn.8xlarge',
    'r6idn.12xlarge',
    'r6idn.16xlarge',
    'r6idn.24xlarge',
    'r6idn.32xlarge',
    'r6in.xlarge',
    'r6in.2xlarge',
    'r6in.4xlarge',
    'r6in.8xlarge',
    'r6in.12xlarge',
    'r6in.16xlarge',
    'r6in.24xlarge',
    'r6in.32xlarge',
    'r7a.xlarge',
    'r7a.2xlarge',
    'r7a.4xlarge',
    'r7a.8xlarge',
    'r7a.12xlarge',
    'r7a.16xlarge',
    'r7a.24xlarge',
    'r7a.32xlarge',
    'r7a.48xlarge',
    'r7g.xlarge',
    'r7g.2xlarge',
    'r7g.4xlarge',
    'r7g.8xlarge',
    'r7g.12xlarge',
    'r7g.16xlarge',
    'r7gd.xlarge',
    'r7gd.2xlarge',
    'r7gd.4xlarge',
    'r7gd.8xlarge',
    'r7gd.12xlarge',
    'r7gd.16xlarge',
    'r7i.xlarge',
    'r7i.2xlarge',
    'r7i.4xlarge',
    'r7i.8xlarge',
    'r7i.12xlarge',
    'r7i.16xlarge',
    'r7i.24xlarge',
    'r7i.48xlarge',
    'r7iz.xlarge',
    'r7iz.2xlarge',
    'r7iz.4xlarge',
    'r7iz.8xlarge',
    'r7iz.12xlarge',
    'r7iz.16xlarge',
    'r7iz.32xlarge',
    'r8g.xlarge',
    'r8g.2xlarge',
    'r8g.4xlarge',
    'r8g.8xlarge',
    'r8g.12xlarge',
    'r8g.16xlarge',
    'r8g.24xlarge',
    'r8g.48xlarge',
    'x1.16xlarge',
    'x1.32xlarge',
    'x1e.xlarge',
    'x1e.2xlarge',
    'x1e.4xlarge',
    'x1e.8xlarge',
    'x1e.16xlarge',
    'x1e.32xlarge',
    'x2gd.xlarge',
    'x2gd.2xlarge',
    'x2gd.4xlarge',
    'x2gd.8xlarge',
    'x2gd.12xlarge',
    'x2gd.16xlarge',
    'x2idn.16xlarge',
    'x2idn.24xlarge',
    'x2idn.32xlarge',
    'x2iedn.xlarge',
    'x2iedn.2xlarge',
    'x2iedn.4xlarge',
    'x2iedn.8xlarge',
    'x2iedn.16xlarge',
    'x2iedn.24xlarge',
    'x2iedn.32xlarge',
    'x8g.xlarge',
    'x8g.2xlarge',
    'x8g.4xlarge',
    'x8g.8xlarge',
    'x8g.12xlarge',
    'x8g.16xlarge',
    'x8g.24xlarge',
    'x8g.48xlarge',
    'z1d.xlarge',
    'z1d.2xlarge',
    'z1d.3xlarge',
    'z1d.6xlarge',
    'z1d.12xlarge',
  ],
  'Storage-optimized': [
    'd3.2xlarge',
    'd3.4xlarge',
    'd3.8xlarge',
    'd3en.xlarge',
    'd3en.2xlarge',
    'd3en.4xlarge',
    'd3en.6xlarge',
    'd3en.8xlarge',
    'd3en.12xlarge',
    'h1.2xlarge',
    'h1.4xlarge',
    'h1.8xlarge',
    'h1.16xlarge',
    'i3.xlarge',
    'i3.2xlarge',
    'i3.4xlarge',
    'i3.8xlarge',
    'i3.16xlarge',
    'i3en.xlarge',
    'i3en.2xlarge',
    'i3en.3xlarge',
    'i3en.6xlarge',
    'i3en.12xlarge',
    'i3en.24xlarge',
    'i4g.xlarge',
    'i4g.2xlarge',
    'i4g.4xlarge',
    'i4g.8xlarge',
    'i4g.16xlarge',
    'i4i.xlarge',
    'i4i.2xlarge',
    'i4i.4xlarge',
    'i4i.8xlarge',
    'i4i.12xlarge',
    'i4i.16xlarge',
    'i4i.24xlarge',
    'i4i.32xlarge',
    'i7ie.xlarge',
    'i7ie.2xlarge',
    'i7ie.3xlarge',
    'i7ie.6xlarge',
    'i7ie.12xlarge',
    'i7ie.18xlarge',
    'i7ie.24xlarge',
    'i7ie.48xlarge',
    'i8g.xlarge',
    'i8g.2xlarge',
    'i8g.4xlarge',
    'i8g.8xlarge',
    'i8g.12xlarge',
    'i8g.16xlarge',
    'i8g.24xlarge',
    'im4gn.xlarge',
    'im4gn.2xlarge',
    'im4gn.4xlarge',
    'im4gn.8xlarge',
    'im4gn.16xlarge',
    'is4gen.xlarge',
    'is4gen.2xlarge',
    'is4gen.4xlarge',
    'is4gen.8xlarge',
  ],
  'Accelerated computing (GPU)': [
    'f2.12xlarge',
    'f2.48xlarge',
    'g3.4xlarge',
    'g3.8xlarge',
    'g3.16xlarge',
    'g3s.xlarge',
    'g4dn.xlarge',
    'g4dn.2xlarge',
    'g4dn.4xlarge',
    'g4dn.8xlarge',
    'g4dn.12xlarge',
    'g4dn.16xlarge',
    'g5.xlarge',
    'g5.2xlarge',
    'g5.4xlarge',
    'g5.8xlarge',
    'g5.12xlarge',
    'g5.16xlarge',
    'g5.24xlarge',
    'g5.48xlarge',
    'g6.xlarge',
    'g6.2xlarge',
    'g6.4xlarge',
    'g6.8xlarge',
    'g6.12xlarge',
    'g6.16xlarge',
    'g6.24xlarge',
    'g6.48xlarge',
    'g6e.xlarge',
    'g6e.2xlarge',
    'g6e.4xlarge',
    'g6e.8xlarge',
    'g6e.12xlarge',
    'g6e.16xlarge',
    'g6e.24xlarge',
    'g6e.48xlarge',
    'gr6.4xlarge',
    'gr6.8xlarge',
    'p2.xlarge',
    'p2.8xlarge',
    'p2.16xlarge',
    'p3.2xlarge',
    'p3.8xlarge',
    'p3.16xlarge',
    'p5.48xlarge',
  ],
};

const instance_options = Object.keys(hardcodedEmrInstances).map(
  (group, group_ix) =>
    new Object({
      label: group,
      value: 'group_' + group_ix,
      options: hardcodedEmrInstances[group].map(
        (inst) =>
          new Object({
            label: inst,
            value: inst,
            id: inst,
          }),
      ),
    }),
);

const hardcodedManagedScalingUnitTypes = { 'Unit Types': ['Instances'] };

const hardcodedManagedScalingUnitOptions = Object.keys(hardcodedManagedScalingUnitTypes).map(
  (group, group_ix) =>
    new Object({
      label: group,
      value: 'group_' + group_ix,
      options: hardcodedManagedScalingUnitTypes[group].map(
        (inst) =>
          new Object({
            label: inst,
            value: inst,
            id: inst,
          }),
      ),
    }),
);

class ResourceGroupRegion {
  id: number;
  label: string;
  description: string;
  value: string;
}

export const cluster_region_options = new Map<String, Array<ResourceGroupRegion>>();
cluster_region_options.set('us-east-1', [
  {
    id: 0,
    label: 'US East (N. Virginia)',
    description: 'us-east-1',
    value: 'us-east-1',
  },
  {
    id: 1,
    label: 'US East (Ohio)',
    description: 'us-east-2',
    value: 'us-east-2',
  },
  {
    id: 2,
    label: 'US West (Oregon)',
    description: 'us-west-2',
    value: 'us-west-2',
  },
]);
cluster_region_options.set('us-west-2', [
  {
    id: 0,
    label: 'US East (N. Virginia)',
    description: 'us-east-1',
    value: 'us-east-1',
  },
  {
    id: 1,
    label: 'US East (Ohio)',
    description: 'us-east-2',
    value: 'us-east-2',
  },
  {
    id: 2,
    label: 'US West (Oregon)',
    description: 'us-west-2',
    value: 'us-west-2',
  },
]);

export const select_options = {
  clusterRefreshDayHoursInUTC: [...Array(24).keys()].map(
    (i) =>
      new Object({
        id: i,
        label: 1 + ((11 + i) % 12) + (i < 12 ? 'AM' : 'PM'),
        value: i,
      }),
  ),
  clusterRefreshWeekDaysInUTC: [...Array(7).keys()].map(
    (i) =>
      new Object({
        id: i,
        label: ['M', 'T', 'W', 'Th', 'F', 'Sa', 'Su'][i],
        value: i + 1,
      }),
  ),
  bootstrapActions: [], // Updated Asynchronously
  region: cluster_region_options.get(getRegion()) ?? [
    {
      id: 0,
      label: getRegion(),
      description: getRegion(),
      value: getRegion(),
    },
  ],
  type: [
    {
      id: 0,
      label: 'EMR Cluster',
      value: 'EMR_GROUP',
    },
  ],
  masterInstanceType: [...instance_options],
  coreInstanceType: [...instance_options],
  taskInstanceType: [...instance_options],
  unitType: [...hardcodedManagedScalingUnitOptions],
};
